var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8877 14.0161C52.265 11.703 50.4413 9.87933 48.1283 9.2566C43.9026 8.1001 26.9999 8.1001 26.9999 8.1001C26.9999 8.1001 10.0972 8.1001 5.87147 9.21212C3.60295 9.83485 1.73475 11.703 1.11202 14.0161C0 18.2417 0 27.0045 0 27.0045C0 27.0045 0 35.8117 1.11202 39.9929C1.73475 42.3059 3.55847 44.1296 5.87147 44.7523C10.1416 45.9088 26.9999 45.9088 26.9999 45.9088C26.9999 45.9088 43.9026 45.9088 48.1283 44.7968C50.4413 44.1741 52.265 42.3504 52.8877 40.0374C53.9998 35.8117 53.9998 27.0489 53.9998 27.0489C53.9998 27.0489 54.0443 18.2417 52.8877 14.0161Z",
    fill: "#DC4200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6172 35.0997L35.6731 27.0042L21.6172 18.9087V35.0997Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYoutube);
export default __webpack_public_path__ + "static/media/footer_youtube.f114f2fe95ce6997da9f9cc81232a7da.svg";
export { ForwardRef as ReactComponent };